import React from 'react';
import { PaymentOptionType } from '@/types/components';

const paymentTypeChipClass: Record<PaymentOptionType, string> = {
  [PaymentOptionType.Recurring]: 'bg-accent contrast:text-accent-foreground',
  [PaymentOptionType.Year]: 'bg-green',
  [PaymentOptionType.Month]: 'bg-purple',
  [PaymentOptionType.Sms]: 'bg-red',
  [PaymentOptionType.NextYear]: 'bg-partner-tasks',
};

interface Props {
  type: PaymentOptionType;
  label: string;
}

export const PlanChip: React.FC<Props> = ({ type, label }) => (
  <span
    className={`inline-flex w-fit items-center justify-center rounded-[40px] px-3 py-1 text-caption-13 text-primary-foreground md:text-subhead-14 ${paymentTypeChipClass[type]}`}
  >
    {label}
  </span>
);
